/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GoalType = "completable" | "continuous" | "%future added value";
export type GoalDetailsSettingsReviewMode_goal = {
    readonly archived: boolean | null;
    readonly type: GoalType;
    readonly reviewMode: {
        readonly spacedRepetition: boolean;
        readonly cycleBegin: {
            readonly days: number | null;
            readonly months: number | null;
        };
        readonly cycleGoal: {
            readonly days: number | null;
            readonly months: number | null;
        } | null;
    };
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsSettingsReviewCycleMode_goal" | "GoalDetailsSettingsReviewCycleBegin_goal" | "GoalDetailsSettingsReviewCycleGoal_goal" | "GoalDetailsSettingsReviewCycleNextReview_goal" | "GoalDetailsSettingsRepetitionLevel_goal">;
    readonly " $refType": "GoalDetailsSettingsReviewMode_goal";
};
export type GoalDetailsSettingsReviewMode_goal$data = GoalDetailsSettingsReviewMode_goal;
export type GoalDetailsSettingsReviewMode_goal$key = {
    readonly " $data"?: GoalDetailsSettingsReviewMode_goal$data;
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsSettingsReviewMode_goal">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "days",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "months",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GoalDetailsSettingsReviewMode_goal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReviewMode",
      "kind": "LinkedField",
      "name": "reviewMode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "spacedRepetition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ReviewCycle",
          "kind": "LinkedField",
          "name": "cycleBegin",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ReviewCycle",
          "kind": "LinkedField",
          "name": "cycleGoal",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GoalDetailsSettingsReviewCycleMode_goal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GoalDetailsSettingsReviewCycleBegin_goal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GoalDetailsSettingsReviewCycleGoal_goal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GoalDetailsSettingsReviewCycleNextReview_goal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GoalDetailsSettingsRepetitionLevel_goal"
    }
  ],
  "type": "Goal",
  "abstractKey": null
};
})();
(node as any).hash = '1c052bf5b954a99fa5179e34e5d1d5c3';
export default node;
